import { useSelector } from 'react-redux';
import useCardView from '../../../../hooks/useCardView';
import classnames from 'classnames';
import { MemberPriceContainerV2 } from './MemberPriceContainerV2';
import FormatterV1 from '../V1/FormatterV1';
import { SaveWasContainerV1 } from '../V1/SaveWasContainerV1';
import { DeliveryTooltip } from './DeliveryTooltip';
import React from 'react';

const PricePodV2 = ({
	classes,
	viewModel: {
		NowPrice,
		WasPrice,
		SavePrice,
		RetailPriceIncVat,
		RetailPriceSavings,
		MemberPrice,
		ProductMemberPriceFinanceQuote,
		PriceWithDelivery,
		MemberUpfrontPaymentAmount,
		upfrontPaymentAmount,
		UpfrontPaymentPercentage,
	} = {},
	inStock,
	FullTitle,
	Promotions: { FinancePromotions } = {},
	Code,
	ColourId,
	State,
	exVat,
}) => {
	const { isDealsPage } = useSelector((state) => state);
	const { isListView } = useCardView();
	if (!NowPrice) {
		return null;
	}

	const dealAvailable = SavePrice > 0 || RetailPriceSavings > 0;

	const displayWasPrice = WasPrice > 0 && SavePrice > 0;
	const displayMemberPrice = MemberPrice > 0;

	const was = displayWasPrice ? WasPrice : RetailPriceIncVat;
	const save = displayWasPrice ? SavePrice : RetailPriceSavings;
	const freeDelivery = PriceWithDelivery === NowPrice;

	return (
		<div
			className={classnames(classes, {
				'mt-2 md:mt-0': !isDealsPage,
				'flex flex-col mb-1': isDealsPage,
				'lg:justify-end': isDealsPage && isListView,
			})}>
			{displayMemberPrice && (
				<MemberPriceContainerV2
					memberPrice={MemberPrice}
					nowPrice={NowPrice}
					was={was}
					save={save}
					ProductMemberPriceFinanceQuote={ProductMemberPriceFinanceQuote}
					inStock={inStock}
					Code={Code}
					ColourId={ColourId}
					financeType={null}
					State={State}
					FinancePromotions={FinancePromotions}
					productTitle={FullTitle}
					memberPricePod={true}
					memberUpfrontPaymentAmount={MemberUpfrontPaymentAmount}
					upfrontPaymentAmount={upfrontPaymentAmount}
					upfrontPaymentPercentage={UpfrontPaymentPercentage}
				/>
			)}

			{displayMemberPrice ? (
				<div className="flex flex-col mt-2 2xl:mt-2 items-baseline border border-gray-30 rounded border-solid px-3 py-2">
					<span className="text-title-sm mb-1">Non-member price</span>
					<div className="flex flex-col xl:flex-row xl:items-baseline">
						<div
							className={classnames('text-left', {
								'h-6 md:h-auto': was && save,
								'text-deals': dealAvailable,
								'text-display-lg': isDealsPage,
								'text-title-lg lg:text-xl main-price mb-1': !isDealsPage,
								'lg:text-title-lg': isDealsPage && isListView,
								'text-primary md:mr-0': displayMemberPrice,
							})}
							data-testid="price-now">
							{FormatterV1.format(NowPrice)}
						</div>

						{was > 0 && save > 0 && (
							<SaveWasContainerV1
								{...{ was, save, displayWasPrice, displayMemberPrice }}
							/>
						)}
					</div>
					<div className="flex flex-row items-baseline">
						<span className="text-body-xs text-water font-bold">
							{freeDelivery
								? 'Free Delivery'
								: `${FormatterV1.format(PriceWithDelivery)} with delivery`}
						</span>
						<DeliveryTooltip />
					</div>
				</div>
			) : (
				<>
					<div className="flex mt-2 lg:mt-0 2xl:mt-2 items-baseline flex-col border border-gray-30 rounded border-solid p-2">
						<div
							className={`flex flex-col xl:flex-row ${
								exVat ? '' : 'items-baseline'
							}`}>
							<div
								className={classnames('text-left pr-1', {
									'h-6 md:h-auto': was && save,
									'text-deals': dealAvailable,
									'text-display-lg': isDealsPage,
									'text-title-lg lg:text-xl main-price mb-1': !isDealsPage,
									'lg:text-title-lg': isDealsPage && isListView,
									'text-primary md:mr-0 pl-2': displayMemberPrice,
								})}
								data-testid="price-now">
								{FormatterV1.format(NowPrice)}
							</div>

							{was > 0 && save > 0 && (
								<SaveWasContainerV1
									{...{ was, save, displayWasPrice, displayMemberPrice }}
								/>
							)}
						</div>
						{exVat && <span className="text-caption">Ex VAT</span>}
						<div className="flex flex-row items-baseline">
							<span className="text-body-xs text-water font-bold">
								{freeDelivery
									? 'Free Delivery'
									: `${FormatterV1.format(PriceWithDelivery)} with delivery`}
							</span>
							<DeliveryTooltip />
						</div>
					</div>
				</>
			)}
		</div>
	);
};

export default PricePodV2;
